import { Property } from '@model';

export function randomElement<T>(collection: T[]): T {
  return collection[Math.floor(Math.random() * collection.length)];
}

export function randomElements<T>(collection: T[], count: number): T[] {
  return collection
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .slice(0, count)
    .map(({ value }) => value);
}

export function extractFilter(key: keyof Property, properties: Property[]) {
  return [
    ...properties
      .reduce((acc, prop) => {
        // Filterable keys (aim, area, category, ...) hold string values
        const value = prop[key] as string;
        if (!acc.has(value)) {
          acc.set(value, 0);
        }
        acc.set(value, acc.get(value)! + 1);
        return acc;
      }, new Map<string, number>())
      .entries(),
  ]
    .filter(([item, count]) => item && count > 0)
    .map(([item, count]) => ({ text: item, count }));
}

export type PropsWithType<O, T> = {
  [K in keyof O as O[K] extends T ? K : never]: O[K];
};
